import React, { useEffect, useRef } from 'react';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import mainPic from '/assets/images/2022aug/milky_main.png';
import milky_image01 from '/assets/images/2022aug/milky_image01.png';
import milky_image02 from '/assets/images/2022aug/milky_image02.png';

import ProductTemplate from "./ProductTemplate";


const ProductMilky = () => {

    // const target = useRef(null);

    // useEffect(() => {
    //     ScrollTrigger.matchMedia({
    //         "(min-width: 768px)": function() {
    //             ScrollTrigger.create({
    //                 trigger: target.current,
    //                 pin: '.product__mainTitle',
    //                 start: "top 50",
    //                 end: "bottom-=10% center",
    //                 // markers: true,
    //                 });
    //             },
    //         "(max-width: 767px)": function() {
    //         ScrollTrigger.create({
    //             trigger: target.current,
    //             pin: '.product__mainTitle',
    //             start: "top 30",
    //             end: "bottom-=20% center",
    //             // markers: true,
    //             });
    //         },
    //         }); 
    // },[]);

    const milkyInfo = {
        className: "product milky",
        id: "milky",
        copy: "今っぽいのはこびない洒落感\n垢抜けメルトブラウン",
        src: mainPic,
        alt: "MILKY & CARAMEL COCO",
        cardData: [
            {
                className: "product__group product__group--01", 
                src: milky_image01,
                alt: "WONDER LIP TINT",
                title: "WONDER LIP TINT",
                price: "1,590 (tax in)",
                text: "甘くほろ苦い\n絶妙なキャラメルブラウン",
                url: "https://uchoobeauty.com/products/lip_caramelcoco"
            },
            {
                className: "product__group product__group--02", 
                src: milky_image02,
                alt: "GLAM EYE SHADOW",
                title: "GLAM EYE SHADOW",
                price: "2,190 (tax in)",
                text: "温かみあふれる\nミルキーでコクのあるラテブラウン",
                url: "https://uchoobeauty.com/products/eye_milkycoco"
            }
        ]
    }

    return (
        <ProductTemplate {...milkyInfo}/>
    )
}

export default ProductMilky